/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShareModel } from '../../models/share-model';

export interface UserShareV20OrganizationCoordinationShareGet$Params {

/**
 * The id of the Organization.
 */
  organizationId: string;

/**
 * The id of the Coordination.
 */
  coordinationId: string;

/**
 * The id of the Share.
 */
  id: string;
  'api-version'?: string;
}

export function userShareV20OrganizationCoordinationShareGet(http: HttpClient, rootUrl: string, params: UserShareV20OrganizationCoordinationShareGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareModel>> {
  const rb = new RequestBuilder(rootUrl, userShareV20OrganizationCoordinationShareGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('coordinationId', params.coordinationId, {});
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShareModel>;
    })
  );
}

userShareV20OrganizationCoordinationShareGet.PATH = '/api/user-share/v2-0/organization/{organizationId}/coordination/{coordinationId}/share/{id}';
